import { t } from 'i18next';
import { AccountNav } from '../Account/AccountNav';
import ContactForm from '../../components/Contact/ContactForm';

const Feedback = () => {
  return (
    <div
      className={
        'flex flex-col w-full bg-white text-black items-center dark:bg-black-real dark:text-white'
      }
    >
      <div className="w-full lg:w-2/3X">
        <AccountNav />
        <div className={'my-6'}>
          <ContactForm
            type={`BUG`}
            placeholder={t('feedback.bug.placeholder')}
            title={t('feedback.bug.title')}
            subtitle={t('feedback.bug.description')}
            buttonText={t('feedback.bug.button')}
            buttonPosition={'right'}
            attachmentActive={true}
          />
        </div>
        <div className={'my-6'}>
          <ContactForm
            type={`FEATURE`}
            placeholder={t('feedback.feature.placeholder')}
            title={t('feedback.feature.title')}
            subtitle={t('feedback.feature.description')}
            buttonPosition={'right'}
            buttonText={t('feedback.feature.button')}
          />
        </div>
      </div>
    </div>
  );
};

export default Feedback;
